/**
 * LogoutCommand - Logs the user out via POST /logout with CSRF token
 * Follows MediatR pattern (Command + Handler in same file)
 */

import type { ICommand, ICommandHandler, IHttpClient } from '@/application/core';

// ============================================================================
// Command (Request)
// ============================================================================

export class LogoutCommand implements ICommand<void> {
  readonly type = 'LogoutCommand' as const;

  constructor(public readonly csrfToken?: string) {}
}

// ============================================================================
// Handler
// ============================================================================

export class LogoutCommandHandler implements ICommandHandler<LogoutCommand, void> {
  constructor(private readonly httpClient: IHttpClient) {}

  async handle(command: LogoutCommand): Promise<void> {
    await this.httpClient.post('/logout', undefined, {
      headers: {
        'Content-Type': 'application/json',
        ...(command.csrfToken && { RequestVerificationToken: command.csrfToken }),
      },
    });
  }
}
